import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react'
import qs from 'querystring'
import { useLocation } from 'react-router-dom'
import classes from '../../assets/sass/style.module.scss'
import { regionConfigValue } from '../../utils/regionConfigValue'
import addSearchParamsToURL from '../../utils/addSearchParamsToURL'
import parseTokens from "../../utils/parseToken";
import style from './max.module.scss';

import {
    LmPopup,
    LmPopupHeader,
    LmPopupBody,
    LmPopupFooter,
    useToggleState,
    LmText,
    LmRing,
    LmInput, LmIcon,
} from '@mes-ui/lemma';
import MaxLogo from 'assets/img/max-logo.png'
import MaxCode from 'assets/img/max-code.png'
import {request} from "../../API/request";
import {getLast10Digits, getUserPhone} from "../../utils/connectmax";
import CodeInput from "./CodeInput";
import { ymReachGoal } from '../../utils/metrics'

export const MaxModal = ({ user, openMax, onCloseMax, onOpenDone, mobile, loadingConnect, isConnectMax }) => {
    const location = useLocation();
    const { SERVICE_URL } = regionConfigValue();
    const isMsk = (SERVICE_URL === 'https://school.mos.ru') || (SERVICE_URL === 'https://school-dev.mos.ru') || SERVICE_URL === 'https://school-test.mos.ru'
    const parseToken = parseTokens();

    /**
     * Проверка параметра
     */
    const checkReturnUrl = useCallback((urlString) => {
        if (!urlString) {
            return false;
        }
        return urlString.length > 1;
    }, []);

    const [phone, setPhone] = useState('');
    const [code, setCode] = useState('');

    const validPhone = useMemo(() => {
        return getLast10Digits(phone)?.length === 10;
    }, [phone]);

    const validCode = useMemo(() => {
        return code?.length === 6;
    }, [code]);

    
    const isYmSend = useRef(false);

    const handleChangePhone = useCallback((value) => {
        const onlyNumbersValue = String(value).replace(/\D/g, '');

        // Отправляем цель при вводе первой цифры номера и только один раз
        if (!isYmSend.current && onlyNumbersValue.length === 1) {
            const { return_url } = qs.parse(location.search.replace('?', ''));

            ymReachGoal('spherumBindingInputPhone', { spherumSource: return_url });

            isYmSend.current = true;
        }

        setPhone(value);
    }, [location.search]);

    const handleGetPhone = useCallback(async () => {
        if (!Boolean(parseToken?.stf)) return '';

        const phone = await getUserPhone(parseToken?.stf).then((data => data));
        setPhone(phone);
    }, [parseToken]);

    const [maxError, setMaxError] = useToggleState(false);
    const [maxCodeWrite, setMaxCodeWrite] = useToggleState(false);

    const [loadingCode, setLoadingCode] = useToggleState(false);
    const [loadingCodeErrorText, setLoadingCodeErrorText] = useState('');

    const [loadingSendCode, setLoadingSendCode] = useToggleState(false);
    const [loadingSendCodeErrorText, setLoadingSendCodeErrorText] = useState('');

    useEffect(() => {
        if (openMax) {
            handleGetPhone();
        }
    }, [openMax])

    const handlerCloseMax = useCallback(() => {
        onCloseMax()

        setMaxError(false);
        setLoadingCodeErrorText('');
        setLoadingSendCodeErrorText('');
        setMaxCodeWrite(false);
        setCode('');
    }, [onCloseMax]);

    const getErrorMax = () => {
        const link = isMsk ? 'https://school.mos.ru/help/instructions/sferum/' : 'https://myschool.mos.ru/help/instructions/sferum/';
        return (
            <>Пользователь с указанным номером телефона не найден в МАХ. Для подключения Сферум пройдите предварительную регистрацию в МАХ, используя <a className={classes['link-blue']} rel="noopener noreferrer" target="_blank" href={link}>инструкцию</a></>
        )
    };

    /**
     * Получение кода
     * Если ответ 200 ОК без тела, переходить на след. экран.
     Код 200 OK с телом {"response":{"error":"text"}} - выводить сообщение из ответа.
     Код 401 - отправлять на авторизацию.
     Код 400 - если в теле WRONG_PHONE_FORMAT (по идее невозможно, но тем не менее) - выводить валидационное сообщение про формат телефона (см. выше)
     Код 499 - если в теле SFERUM_API_ERROR, а также при любых других ошибках - переходить на экран "Не удалось подключить Сферум".
     Если при кодах 401, 499 и любых других неописанных выше ошибках в url есть параметр return_url, то сразу переходить на этот урл с добавлением параметра bindingError, минуя экран с ошибкой.
     */
    const handleGetCode = useCallback(() => {

        ymReachGoal('spherumBindingInputPhoneContinue');

        setLoadingCode(true);

        const { return_url } = qs.parse(location.search.replace('?', ''));

        request({
            method: 'post',
            url: `/v3/max/send-phone?phone=7${getLast10Digits(phone)}`
        }, true).then(({ data, status }) => {

            if (status === 200 && !data) {
                setLoadingCodeErrorText('');
                setMaxCodeWrite(true);
            }

            setLoadingCode(false);
        }).catch((error) => {            
            ymReachGoal('spherumBindingError', { errorName: error?.data?.error});

            if (error.status === 200 && error.data?.error) {

                /**
                 * https://jira.mos.social/browse/ETD-8370
                 */
                if (error.data?.error === 'Пользователь не найден') {
                    setLoadingCodeErrorText(getErrorMax());
                } else {
                    setLoadingCodeErrorText(error.data?.error);
                }

            } else if (error.error === 'WRONG_PHONE_FORMAT') {
                setLoadingCodeErrorText('Введите 10 цифр номера телефона (без восьмёрки)')
            } else {
                if (checkReturnUrl(return_url)) {
                    handlerCloseMax();
                    window.location = addSearchParamsToURL(return_url, 'bindingError', '1')
                } else {
                    setMaxError(true);
                    setLoadingCodeErrorText('');
                }
            }
            setLoadingCode(false);
        })
    }, [phone, checkReturnUrl]);

    const handleGetCodeAgain = useCallback(() => {
        ymReachGoal('spherumBindingErrorNewTry');

        setMaxError(false);
        setMaxCodeWrite(false);
        setCode('');
        setLoadingSendCodeErrorText('');
    }, []);

    const handleCodeComplete = (code) => {
        setCode(code)
    };

    /**
     * Отправка кода
     * Если ответ 200 ОК с телом {"bindnig":true, "max_id":"ZZZZZZZZ"} - переходить на экран "Успешно подключили". Если при этом в url есть параметр return_url, то сразу переходить на этот урл, минуя доп. экран. На основной странице (под попапом) менять кнопку "Подключить" на "Отвязать" и отображать подключённый id, пришедший в ответ.
     Код 200 ОК с телом {"binding":false, "error":"text"} - подсвечивать поля кода красным, выводить текст ошибки под кодом.
     Код 401 - отправлять на авторизацию.
     Код 499 - если в теле SFERUM_API_ERROR, а также при любых других ошибках - переходить на экран "Не удалось подключить Сферум".
     Как и выше, если при кодах 401, 499 и любых других неописанных выше ошибках в url есть параметр return_url, то сразу переходить на этот урл с добавлением параметра bindingError, минуя экран с ошибкой.
     */
    const handleSendCode = useCallback(() => {
        ymReachGoal('spherumBindingInputPinCodeContinue');

        setLoadingSendCode(true);

        const { return_url } = qs.parse(location.search.replace('?', ''));

        request({
            method: 'post',
            url: `/v3/max/send-code?phone=7${getLast10Digits(phone)}&code=${code}`
        }, true).then(({ data, status }) => {

            if (status === 200 && data?.binding) {

                handlerCloseMax();

                if (checkReturnUrl(return_url)) {
                    window.location = return_url;
                } else {
                    onOpenDone()
                }
            }

            setLoadingSendCode(false);
        }).catch((error) => {
            ymReachGoal('spherumBindingError', { errorName: error?.data?.error});

            if (error.status === 200 && !error.data?.binding) {

                setLoadingSendCodeErrorText(error.data?.error);
            } else {
                if (checkReturnUrl(return_url)) {
                    handlerCloseMax();
                    window.location = addSearchParamsToURL(return_url, 'bindingError', '1')
                } else {
                    setMaxError(true);
                    setMaxCodeWrite(false);
                    setLoadingSendCodeErrorText('');
                }
            }

            setLoadingSendCode(false);
        })

    }, [code, phone, checkReturnUrl, onOpenDone]);

    return (
        <>
            <LmPopup
                className={`${style.MaxModal} ${mobile ? style.MaxMobile : ''}`}
                isOpenModal={openMax}
                onCloseModal={handlerCloseMax}
                isOpenOverlay size={'medium-M'}
                styleVariant={'B2C'}>

                {!mobile && <LmPopupHeader className={style.MaxHeader} title={'Профиль Сферум'} onCloseModal={handlerCloseMax} hideReturnButton />}



                <LmPopupBody style={{ overflowY: 'auto' }}>

                    <div className={style.MaxContent}>

                        {maxError && (
                            <div className={style.MaxContentError}>
                                <LmIcon className={style.MaxContentErrorIcon} icon="outline-notifications-alert-triangle" size={52} />
                                <LmText variant={'h5'}>Не удалось подключить Сферум</LmText>
                                <LmText color={'note'} variant={'lg'} weight={'regular'}>Подождите и попробуйте подключить Сферум ещё раз</LmText>
                            </div>
                        )}

                        {maxCodeWrite && (
                            <div className={style.MaxContentBox}>

                                <div className={style.MaxContentImg}>
                                    <img src={MaxCode} className={style.MaxLogo} alt=""/>
                                </div>

                                <div className={style.MaxContentText}>
                                    <LmText variant={'h5'}>Какой код пришёл в MAX?</LmText>
                                    <LmText color={'note'} variant={'lg'} weight={'regular'}>Отправили на номер {phone}</LmText>
                                </div>

                                <CodeInput
                                    disabled={loadingSendCode}
                                    error={loadingSendCodeErrorText}
                                    onComplete={handleCodeComplete}
                                />
                            </div>
                        )}

                        {(!maxCodeWrite && !maxError) && (
                            <div className={style.MaxContentBox}>

                                <div className={style.MaxContentImg}>
                                    <img src={MaxLogo} className={style.MaxLogo} alt=""/>
                                </div>

                                {loadingConnect ? (<div className={style.MaxContentLoader}><LmRing color={'gray'} /></div>) : (
                                    <>

                                        {isConnectMax ? (
                                            <div className={style.MaxContentText}>
                                                <LmText variant={'h5'}>Учебный профиль Сферум подключен</LmText>
                                            </div>
                                        ) : (
                                            <>
                                                <div className={style.MaxContentText}>
                                                    <LmText variant={'h5'}>Введите номер,<br/>чтобы подключить Сферум</LmText>
                                                    <LmText color={'note'} variant={'lg'} weight={'regular'}>Подтверждение придёт в MAX</LmText>
                                                </div>

                                                {Boolean(user) && (
                                                    <div className={style.MaxContentUser}>
                                                        <LmIcon className={style.MaxContentUserIcon} icon="outline-account-person" size={20} />
                                                        <div className={style.MaxContentUserName}>

                                                            <LmText variant={'lg'} weight={'medium'} ellipsis nowrap>
                                                                {user?.info?.LastName} {user?.info?.FirstName} {user?.info?.MiddleName}
                                                            </LmText>

                                                            {!!user?.roles.length && (
                                                                <LmText color={'note'} variant={'lg'} weight={'regular'} ellipsis nowrap>
                                                                    {user?.roles?.map(i => i.title)?.join(', ')}
                                                                </LmText>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                <LmInput
                                                    styleVariant={'B2B'}
                                                    leftPrefix={'+7'}
                                                    resettable
                                                    value={phone}
                                                    disabled={loadingCode}
                                                    explainText={loadingCodeErrorText}
                                                    isError={loadingCodeErrorText?.length > 0 || Object.keys(loadingCodeErrorText)?.length > 0}
                                                    inputSize={'large'}
                                                    onChange={handleChangePhone}
                                                    label='Номер телефона'
                                                    labelPosition='fix'
                                                    type={'tel'}
                                                    maskRegex={['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]}
                                                    placeholder={'(000) 000-00-00'}
                                                    id='phone'
                                                />
                                            </>
                                        )}
                                    </>
                                )}
                            </div>
                        )}

                    </div>

                </LmPopupBody>
                {!isConnectMax && (
                    <LmPopupFooter
                        buttonSecondaryText={!mobile ? 'Отмена' : ''}
                        additionalButtonText={maxCodeWrite && 'Назад'}
                        onClickAdditionalButton={maxCodeWrite && handleGetCodeAgain}
                        additionalButtonModifiers={{ size: 'large' }}
                        buttonPrimaryText={maxError ? 'Попробовать ещё раз' : maxCodeWrite ? 'Отправить' : 'Продолжить'}
                        onClickSecondaryButton={!mobile ? handlerCloseMax : null}
                        secondaryButtonModifiers={{ size: 'large', disabled: loadingCode || loadingSendCode || loadingConnect }}
                        primaryButtonModifiers={{
                            size: 'large',
                            disabled: (maxCodeWrite ? !validCode : !validPhone) || loadingConnect,
                            loading: loadingCode || loadingSendCode
                        }}
                        onClickPrimaryButton={maxError ? handleGetCodeAgain : maxCodeWrite ? handleSendCode : handleGetCode}
                    />
                )}
            </LmPopup>
        </>
    )
}
